import { ReactComponent as GreenTick } from "@/assets/svgs/green-tick.svg";
import { ReactComponent as CheckHistorySolidSmall } from "@/assets/svgs/check-history-solid-small.svg";
import { ReactComponent as IconExclamationCircleRed } from "@/assets/svgs/exclamation-circle-solid-small.svg";
import { ReactComponent as IconRevoked } from "@/assets/svgs/etr-revoked-status-icon.svg";
import { ReactComponent as IconSurrendered } from "@/assets/svgs/etr-surrendered-status-icon.svg";
import { ReactComponent as IconReturn } from "@/assets/svgs/etr-return-status-icon.svg";
import { ReactComponent as IconXCircle } from "@/assets/svgs/x-circle.svg";
import { ReactComponent as IconClocked } from "@/assets/svgs/clock.svg";
import { ReactComponent as CheckCircle } from "@/assets/svgs/etr-maker-checker-circle.svg";
import { ReactComponent as CheckFilledCircle } from "@/assets/svgs/etr-maker-checker-filled-circle.svg";
import classname from "classnames";
import { etrActions, getIconFillColorType } from "@/constants/etr/etr-action/index";
import PropTypes from 'prop-types';

// Get ETR Maker Checker Status
function GetETRMakerCheckerStatus({
    eventStatus,
    status,
    transactionType,
    isApprovalScreen = false,
    isListView = false,
    transferableStoreType,
    action,
    beneficiaryInfo,
    storeStatus = null
}) {
    const eventStatusForSteps = ["surrender_failed", "surrender_pending_approval", "nomination_pending_approval", "nomination_failed", "nomination_rejected", "endorsement_pending_approval", "endorsement_rejected", "endorsement_failed", "surrender_rejected"];
    const iconFillColor = getIconFillColorType(isApprovalScreen, storeStatus, status)
    const renderNominatedStepStatus = (containerClass) => {
        return (
            <div className={containerClass}>
                <div className="etr-maker-checker-view-request-log">
                    <div className="etr-maker-checker-view-request-log-icon"><CheckCircle /></div>
                    <div className="etr-data-list-status-ticked">
                        <GreenTick />
                        <span>Issued</span>
                    </div>
                </div>
                <div className="etr-maker-checker-view-request-log">
                    <div className={`etr-maker-checker-view-request-log-icon etr-maker-checker-view-request-log-icon--${iconFillColor}`}><CheckFilledCircle /></div>
                    <div className="etr-data-list-status-nominated">
                        <IconClocked />
                        <span>Nominated</span>
                    </div>
                </div>
            </div>
        );
    }
    const renderEndrosementStepStatus = (containerClass) => {
        return (
            <div className={containerClass}>
                <div className="etr-maker-checker-view-request-log">
                    <div className="etr-maker-checker-view-request-log-icon"><CheckCircle /></div>
                    <div className="etr-data-list-status-nominated">
                        <IconClocked />
                        <span>Nominated</span>
                    </div>
                </div>
                <div className="etr-maker-checker-view-request-log">
                    <div className={`etr-maker-checker-view-request-log-icon etr-maker-checker-view-request-log-icon--${iconFillColor}`}><CheckFilledCircle /></div>
                    <div className="etr-data-list-status-ticked">
                        <GreenTick />
                        <span>Issued</span>
                    </div>
                </div>
            </div>
        )
    }
    const renderSurrenderStepStatus = (containerClass) => {
        return (
            <div className={containerClass}>
                <div className="etr-maker-checker-view-request-log">
                    <div className="etr-maker-checker-view-request-log-icon"><CheckCircle /></div>
                    <div className="etr-data-list-status-ticked">
                        <GreenTick />
                        <span>Issued</span>
                    </div>
                </div>
                <div className="etr-maker-checker-view-request-log">
                    <div className={`etr-maker-checker-view-request-log-icon etr-maker-checker-view-request-log-icon--${iconFillColor}`}><CheckFilledCircle /></div>
                    <div className="etr-data-list-status-surrendered">
                        <IconSurrendered />
                        <span>{"Surrendered"}</span>
                    </div>
                </div>
            </div>
        )
    }
    const renderShredStepStatus = (containerClass) => {
        return (
            <div className={containerClass}>
                <div className="etr-maker-checker-view-request-log">
                    <div className="etr-maker-checker-view-request-log-icon"><CheckCircle /></div>
                    <div className="etr-data-list-status-surrendered">
                        <IconReturn />
                        <span>Surrendered</span>
                    </div>
                </div>
                <div className="etr-maker-checker-view-request-log">
                    <div className={`etr-maker-checker-view-request-log-icon etr-maker-checker-view-request-log-icon--${iconFillColor}`}><CheckFilledCircle /></div>
                    <div className="etr-data-list-status-shredded">
                        <IconXCircle />
                        <span>Shredded</span>
                    </div>
                </div>
            </div>
        )
    }

    const renderRestoreStepStatus = (containerClass) => {
        console.log("iconFillColor", iconFillColor);
        return (
            <div className={containerClass}>
                <div className="etr-maker-checker-view-request-log">
                    <div className="etr-maker-checker-view-request-log-icon"><CheckCircle /></div>
                    <div className="etr-data-list-status-surrendered">
                        <IconReturn />
                        <span>Surrendered</span>
                    </div>
                </div>
                <div className="etr-maker-checker-view-request-log">
                    <div className={`etr-maker-checker-view-request-log-icon etr-maker-checker-view-request-log-icon--${iconFillColor}`}><CheckFilledCircle /></div>
                    <div className="etr-data-list-status-ticked">
                        <GreenTick />
                        <span>Issued</span>
                    </div>
                </div>
            </div>
        )
    }

    const containerClassesForStatuses = classname({
        'etr-maker-checker__step-status-container': true,
        'etr-maker-checker__container-pending': ["nomination_pending_approval", "endorsement_pending_approval", "surrender_pending_approval"].includes(eventStatus),
        'etr-maker-checker__container-transferring': ["nomination_approved", "nominating", "endorsement_approved", "owner_transferring", "surrender_approved"].includes(eventStatus) || ["surrendering"].includes(status),
        'etr-maker-checker__container-rejected-failed': ["nomination_rejected", "nomination_failed", "endorsement_rejected", "endorsement_failed", "surrender_rejected"].includes(eventStatus) || ["surrender_failed"].includes(status) || ["fail"].includes(storeStatus),
        'etr-maker-checker__container-approved': ["approved"].includes(status) && ['NOMINATE_OWNERSHIP'].includes(transactionType),
        'etr-maker-checker__container-rejected': ["rejected"].includes(status) && ['NOMINATE_OWNERSHIP'].includes(transactionType),
    })

    const getApprovalScreenStatues = (itemStatus) => {
        const containerClassesForApprovalStatuses = classname({
            "etr-maker-checker__step-status-container": true,
            "etr-maker-checker__container-pending": [
                "nominate_owner_pending_approval",
                "endorse_owner_pending_approval",
                "surrender_pending_approval"
            ].includes(itemStatus),
            "etr-maker-checker__container-approved": [
                "nominate_owner_approved",
                "endorse_owner_approved",
                "surrender_approved"
            ].includes(itemStatus),
            "etr-maker-checker__container-rejected": [
                "nominate_owner_rejected",
                "endorse_owner_rejected",
                "surrender_rejected"
            ].includes(itemStatus),
        });

        switch (itemStatus) {
            case "transfer_holder_pending_approval":
            case "transfer_owner_pending_approval":
            case "transfer_owner_holder_pending_approval":
            case "transfer_holder_approved":
            case "transfer_owner_approved":
            case "transfer_owner_holder_approved":
            case "transfer_owner_reject_approved":
            case "transfer_holder_reject_approved":
            case "transfer_owner_holder_reject_approved":
            case "transfer_owner_holder_rejected":
            case "transfer_holder_rejected":
            case "transfer_owner_rejected":
            case "transfer_owner_reject_rejected":
            case "transfer_holder_reject_rejected":
            case "transfer_owner_holder_reject_rejected":
            case "transfer_owner_reject_pending_approval":
            case "transfer_holder_reject_pending_approval":
            case "transfer_owner_holder_reject_pending_approval":
                return (
                    <div className="etr-data-list-status-ticked">
                        <GreenTick />
                        <span>Issued</span>
                    </div>
                );
            case "nominate_owner_pending_approval":
            case "nominate_owner_approved":
            case "nominate_owner_rejected":
                return renderNominatedStepStatus(
                    containerClassesForApprovalStatuses
                );
            case "endorse_owner_pending_approval":
            case "endorse_owner_approved":
            case "endorse_owner_rejected":
                return renderEndrosementStepStatus(
                    containerClassesForApprovalStatuses
                );
            case "surrender_pending_approval":
            case "surrender_approved":
            case "surrender_rejected":
                return renderSurrenderStepStatus(containerClassesForApprovalStatuses);
            default:
                return;
        }
    };

    const getRecordDetailStepStatus = (itemStatus) => {
        switch (itemStatus) {
            case "nomination_pending_approval":
            case "nomination_rejected":
            case "nomination_failed":
                return renderNominatedStepStatus(containerClassesForStatuses);
            case "endorsement_pending_approval":
            case "endorsement_rejected":
            case "endorsement_failed":
                return renderEndrosementStepStatus(containerClassesForStatuses);
            case "surrender_pending_approval":
            case "surrender_rejected":
            case "surrender_failed":
                return renderSurrenderStepStatus(containerClassesForStatuses);
            case "shredding_failed":
                return renderShredStepStatus(containerClassesForStatuses)
            case "restore_failed":
                return renderRestoreStepStatus(containerClassesForStatuses);

        }
    }

    function getAssumedEventStatus(status, eventStatus, action, beneficiaryInfo, isListView) {
        const defaultRecordStatuses = new Set(["draft", "issued", "issuing", "issuance_failed", "revoking", "revoked", "surrendering", "surrendered", "restoring", "shredding", "shredded", "surrender_failed", "nominated"]);
        const masterInProgressStatuses = new Set(["issuing", "revoking", "restoring", "surrendering", "shredding", "owner_transferring", "holder_transferring", "owner_holder_transferring", "nominating"]);
        const recognizedInProgressStatuses = new Set(["owner_transferring", "holder_transferring", "owner_holder_transferring", "nominating", "owner_holder_transfer_rejection_in_progress", "owner_transfer_rejection_in_progress", "holder_transfer_rejection_in_progress"]);
        const defaultMCRecordEventStatuses = new Set([
            "issuance_pending_approval", "owner_transfer_pending_approval", "holder_transfer_pending_approval", "owner_holder_transfer_pending_approval", "owner_transfer_rejection_pending_approval", "holder_transfer_rejection_pending_approval", "owner_holder_transfer_rejection_pending_approval", "nomination_pending_approval", "endorsement_pending_approval", "surrender_pending_approval", "restore_pending_approval", "surrender_acceptance_pending_approval",
            "issuance_rejected", "owner_transfer_rejected", "holder_transfer_rejected", "owner_holder_transfer_rejected", "owner_transfer_rejection_rejected", "holder_transfer_rejection_rejected", "owner_holder_transfer_rejection_rejected", "nomination_rejected", "endorsement_rejected", "surrender_rejected", "restore_rejected", "surrender_acceptance_rejected",
            "issuance_failed", "owner_transfer_failed", "holder_transfer_failed", "owner_holder_transfer_failed", "owner_transfer_rejection_failed", "holder_transfer_rejection_failed", "owner_holder_transfer_rejection_failed", "nomination_failed", "endorsement_failed", "surrender_failed", "restore_failed", "surrender_acceptance_failed"
        ]);
        const defaultMCSuccessEventStatuses = new Set([
            "owner_transferred", "holder_transferred", "owner_holder_transferred", "owner_transfer_rejection_approved", "holder_transfer_rejection_approved", "owner_holder_transfer_rejection_approved", "nomination_approved", "issuance_approved", "owner_transfer_approved", "holder_transfer_approved", "owner_holder_transfer_approved", "endorsement_approved", "surrender_approved", "restore_approved", "surrender_acceptance_approved"
        ]);

        const isInProgress = masterInProgressStatuses.has(status) || recognizedInProgressStatuses.has(eventStatus);
        const isSurrenderAction = [etrActions.acceptRejectSurrender, etrActions.surrender].includes(action);
        const isNominatedBeneficiary = beneficiaryInfo?.nominatedBeneficiary && beneficiaryInfo?.nominatedBeneficiary !== beneficiaryInfo.emptyAddress;

        function getMCInprogressStatus(eventStatus, baseStatus) {
            return recognizedInProgressStatuses.has(eventStatus) ? eventStatus : baseStatus;
        }

        function determineFinalStatus(baseStatus, eventStatus) {
            if (isInProgress) {
                return masterInProgressStatuses.has(baseStatus) ? baseStatus : (getMCInprogressStatus(eventStatus, baseStatus));
            }
            if (defaultMCRecordEventStatuses.has(eventStatus)) return eventStatus;
            if (defaultMCSuccessEventStatuses.has(eventStatus)) return baseStatus;
            return baseStatus;
        }

        function handleListView(baseStatus, eventStatus) {
            if (defaultRecordStatuses.has(baseStatus) && !recognizedInProgressStatuses.has(eventStatus) && !defaultMCRecordEventStatuses.has(eventStatus)) {
                if (defaultMCSuccessEventStatuses.has(eventStatus)) return baseStatus;
                if (["nomination_approved", "nominated"].includes(eventStatus)) return "nominated";
            }
            return baseStatus;
        }

        function handleActionSpecificLogic(action, baseStatus, eventStatus, storeStatus) {
            if (isSurrenderAction && !isInProgress && storeStatus === 'fail') {
                if (eventStatus === 'surrender_acceptance_approved') return "shredding_failed";
                if (eventStatus === 'restore_approved') return "restore_failed";
            }
            if (isSurrenderAction && !isInProgress && (["nomination_approved", "nominated"].includes(eventStatus) || !defaultMCRecordEventStatuses.has(eventStatus))) {
                return "surrendered";
            }
            if (action === etrActions.shred && !isInProgress && !defaultMCRecordEventStatuses.has(eventStatus)) {
                return "shredded";
            }
            if ((action === etrActions.holderAndEndorseOwner || isNominatedBeneficiary) && !isInProgress && !defaultMCRecordEventStatuses.has(eventStatus)) {
                return "nominated";
            }
            if ([etrActions.ownerAndHolder, etrActions.holderOnly, etrActions.ownerOnly].includes(action) && !isInProgress) {
                if (defaultMCRecordEventStatuses.has(eventStatus)) {
                    return eventStatus === "nomination_approved" || (action === etrActions.ownerOnly && eventStatus === "nominated") ? "nominated" : eventStatus;
                }
                return "issued";
            }
            return baseStatus;
        }

        let finalStatus = determineFinalStatus(status, eventStatus);

        if (finalStatus === "surrender_failed") {
            return finalStatus;
        }

        if (isListView) {
            finalStatus = handleListView(finalStatus, eventStatus);
        }

        if (action !== etrActions.none) {
            finalStatus = handleActionSpecificLogic(action, finalStatus, eventStatus, storeStatus);
        } else if (!isListView && !isInProgress) {
            finalStatus = status;
        }

        return finalStatus;
    }

    const itemStatus = getAssumedEventStatus(status, eventStatus, action, beneficiaryInfo, isListView);
    if (isApprovalScreen) {
        return { itemStatus, component: getApprovalScreenStatues(`${transferableStoreType}_${status}`.toLowerCase()) };
    }

    if (!isListView && (eventStatusForSteps.includes(itemStatus)) || (["shredding_failed", "restore_failed"].includes(itemStatus))) {
        return { itemStatus, component: getRecordDetailStepStatus(itemStatus) };
    }

    let component;
    switch (itemStatus) {
        case "draft":
            component = (
                <div className="etr-data-list-status">
                    <span className="etr-data-list-status-active">
                        <GreenTick />
                        <span>Draft</span>
                    </span>
                </div>
            );
            break;
        case "issuing":
            component = (
                <div className="etr-data-list-status">
                    <CheckHistorySolidSmall />
                    <span>Issuance In Progress</span>
                </div>
            );
            break;
        case "issued": case "owner_transferred": case "holder_transferred": case "owner_holder_transferred": case "owner_transfer_failed": case "holder_transfer_failed": case "owner_holder_transfer_failed": case "owner_transfer_rejection_failed": case "holder_transfer_rejection_failed": case "owner_holder_transfer_rejection_failed":
        case "owner_transfer_rejected": case "holder_transfer_rejected": case "owner_holder_transfer_rejected": case "owner_transfer_rejection_rejected": case "holder_transfer_rejection_rejected": case "owner_holder_transfer_rejection_rejected":
        case "approved": case "rejected": case "nomination_rejected": case "nomination_failed": case "surrender_rejected": case "surrender_failed":
            component = (
                <div className="etr-data-list-status-ticked">
                    <GreenTick />
                    <span>Issued</span>
                </div>
            );
            break;
        case "owner_transfer_pending_approval": case "holder_transfer_pending_approval": case "owner_holder_transfer_pending_approval": case "owner_transfer_rejection_pending_approval": case "holder_transfer_rejection_pending_approval": case "owner_holder_transfer_rejection_pending_approval":
            component = (
                isListView ? <div className="etr-data-list-status-pending-approval">
                    <CheckHistorySolidSmall />
                    <span>Transfer Pending Approval</span>
                </div> : <div className="etr-data-list-status-ticked">
                    <GreenTick />
                    <span>Issued</span>
                </div>
            );
            break;
        case "issuance_failed":
            component = (
                <div className="etr-data-list-status">
                    <IconExclamationCircleRed />
                    <span>Issuance Failed</span>
                </div>
            );
            break;
        case "revoking":
            component = (
                <div className="etr-data-list-status">
                    <CheckHistorySolidSmall />
                    <span>Revoking In Progress</span>
                </div>
            );
            break;
        case "revoked":
            component = (
                <div className="etr-data-list-status-ticked">
                    <IconRevoked />
                    <span>Revoked</span>
                </div>
            );
            break;
        case "restoring":
            component = (
                <div className="etr-data-list-status">
                    <CheckHistorySolidSmall />
                    <span>{"Surrender Rejection In Progress"}</span>
                </div>
            );
            break;
        case "surrendering": case "surrender_approved":
            component = (
                <div className="etr-data-list-status">
                    <CheckHistorySolidSmall />
                    <span>{"Surrender In Progress"}</span>
                </div>
            );
            break;
        case "surrendered":
            component = (
                <div className="etr-data-list-status-surrendered">
                    <IconSurrendered />
                    <span>{"Surrendered"}</span>
                </div>
            );
            break;
        case "shredding":
            component = (
                <div className="etr-data-list-status">
                    <CheckHistorySolidSmall />
                    <span>Shredding In Progress</span>
                </div>
            );
            break;
        case "shredded":
            component = (
                <div className="etr-data-list-status-shredded">
                    <IconXCircle />
                    <span>Shredded</span>
                </div>
            );
            break;
        case "issuance_pending_approval":
            component = (
                <div className="etr-data-list-status-pending-approval">
                    <CheckHistorySolidSmall />
                    <span>Issuance Pending Approval</span>
                </div>
            );
            break;
        case "surrender_pending_approval":
            component = (
                <div className="etr-data-list-status-pending-approval">
                    <CheckHistorySolidSmall />
                    <span>{"Surrender Pending Approval"}</span>
                </div>
            );
            break;
        case "restore_pending_approval":
            component = (
                <div className="etr-data-list-status-pending-approval">
                    <CheckHistorySolidSmall />
                    <span>{"Surrender Rejection Pending Approval"}</span>
                </div>
            );
            break;
        case "surrender_acceptance_pending_approval":
            component = (
                <div className="etr-data-list-status-pending-approval">
                    <CheckHistorySolidSmall />
                    <span>Shredding Pending Approval</span>
                </div>
            );
            break;
        case "owner_transferring": case "holder_transferring": case "owner_holder_transferring": case "owner_transfer_approved": case "holder_transfer_approved": case "owner_holder_transfer_approved": case "endorsement_approved": case "owner_transfer_rejection_approved": case "holder_transfer_rejection_approved": case "owner_holder_transfer_rejection_approved":
            component = (
                <div className="etr-data-list-status">
                    <CheckHistorySolidSmall />
                    <span>Transfer In Progress</span>
                </div>
            );
            break;
        case "owner_holder_transfer_rejection_in_progress": case "owner_transfer_rejection_in_progress": case "holder_transfer_rejection_in_progress":
            component = (
                <div className="etr-data-list-status">
                    <CheckHistorySolidSmall />
                    <span>Rejection Transfer In Progress</span>
                </div>
            );
            break;
        case "nomination_approved":
        case "nominating":
            component = (
                <div className="etr-data-list-status">
                    <CheckHistorySolidSmall />
                    <span>Nomination In Progress</span>
                </div>
            );
            break;
        case "nomination_pending_approval":
            component = (
                <div className="etr-data-list-status-pending-approval">
                    <CheckHistorySolidSmall />
                    <span>Nomination Pending Approval</span>
                </div>
            );
            break;
        case "endorsement_pending_approval":
            component = (
                <div className="etr-data-list-status-pending-approval">
                    <CheckHistorySolidSmall />
                    <span>Endorsement Pending Approval</span>
                </div>
            );
            break;
        case "endorsement_rejected":
        case "endorsement_failed":
        case "nominated":
            component = (
                <div className="etr-data-list-status-nominated">
                    <IconClocked />
                    <span>Nominated</span>
                </div>
            );
            break;
        default:
            component = null;
    }
    return { itemStatus, component };
}

GetETRMakerCheckerStatus.propTypes = {
    eventStatus: PropTypes.string,
    status: PropTypes.string,
    transactionType: PropTypes.string,
    isApprovalScreen: PropTypes.bool,
    isListView: PropTypes.bool,
    transferableStoreType: PropTypes.string,
    action: PropTypes.string,
    beneficiaryInfo: PropTypes.shape({
        nominatedBeneficiary: PropTypes.string,
        emptyAddress: PropTypes.string
    })
};

export default GetETRMakerCheckerStatus;
